import { format as dateFnsFormat } from 'date-fns'

function parseUTC(date) {
    if (!date || date.startsWith('0000')) {
        return null
    }

    const parsed = date.includes('T') || date.endsWith('Z')
        ? new Date(date)
        : new Date(date.replace(' ', 'T') + 'Z')

    return isNaN(parsed.getTime()) ? null : parsed
}

class DateFns {
    constructor(value) {
        this.parsed = parseUTC(value)
    }

    format(dateFormat) {
        return dateFnsFormat(this.parsed, dateFormat)
    }

    formatLocalDateTime() {
        return this.format('MM/dd/yyyy h:mm a')
    }

    formatLocalDateTimeWithSeconds() {
        return this.format('MM/dd/yyyy h:mm:ss a')
    }

    formatLocalDate() {
        return this.format('MM/dd/yyyy')
    }
}

export function date(value) {
    return new DateFns(value)
}

function formatLocalDates() {
    document.querySelectorAll('time[data-datetime]').forEach((el) => {
        const raw = el.dataset.datetime

        if (!raw) {
            return
        }

        const formatted = window.formatLocalDateTime(raw)

        if (formatted) {
            el.textContent = formatted
        }
    })

    document.querySelectorAll('time[data-datetime-seconds]').forEach((el) => {
        const raw = el.dataset.datetimeSeconds

        if (!raw) {
            return
        }

        const formatted = window.formatLocalDateTimeWithSeconds(raw)

        if (formatted) {
            el.textContent = formatted
        }
    })

    document.querySelectorAll('time[data-date]').forEach((el) => {
        const raw = el.dataset.date

        if (!raw) {
            return
        }

        const formatted = window.formatLocalDate(raw)

        if (formatted) {
            el.textContent = formatted
        }
    })
}

window.date = date

window.formatLocalDateTime = (value) => date(value).formatLocalDateTime()

window.formatLocalDateTimeWithSeconds = (value) => date(value).formatLocalDateTimeWithSeconds()

window.formatLocalDate = (value) => date(value).formatLocalDate()

window.utcToLocalDatetimeInput = (value) => date(value).format("yyyy-MM-dd'T'HH:mm")

window.formatLocalDates = formatLocalDates

document.addEventListener('DOMContentLoaded', formatLocalDates)
document.addEventListener('livewire:updated', formatLocalDates)
